// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__FhCqJ","checkbox":"TodoItem_checkbox__SGVq0","textInput":"TodoItem_textInput__N-Hkl"};